// extracted by mini-css-extract-plugin
export var footer = "_r6-0";
export var inherit = "_r6-1";
export var input = "_r6-2";
export var modalContent = "_r6-3";
export var quillEditor = "_r6-4";
export var subtitle = "_r6-5";